import React, { useState, useMemo } from 'react';
import { buscarSuenos } from './mecanicasJuegos';
import './Simulador.css';

/* La tabla de los sueños, del 00 al 99, buscable.
   Antes vivía escondida como pie de página de un número aleatorio: se veía
   una entrada de cien. Acá es una pieza propia y se puede buscar por palabra
   ("perro") o por número ("42").

   Es tradición popular, no una regla del juego, y así lo dice en pantalla:
   soñar con un perro no cambia la probabilidad de nada.

   Es una tabla de verdad —<table>, <th scope>— y no una grilla de <div>:
   número y significado son columnas de una misma fila y así se leen. */

export default function TablaSuenos({ onJugar }) {
  const [consulta, setConsulta] = useState('');
  const filas = useMemo(() => buscarSuenos(consulta), [consulta]);

  return (
    <div className="sim sim-suenos">
      <div className="sim-busca">
        <label className="sim-busca-lab" htmlFor="sim-busca">Sueño o número</label>
        <div className="sim-busca-caja">
          <svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true" focusable="false">
            <circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" strokeWidth="2.2" />
            <path d="M15.4 15.4L21 21" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
          </svg>
          <input
            id="sim-busca"
            className="sim-busca-inp"
            type="text"
            inputMode="search"
            autoComplete="off"
            value={consulta}
            placeholder="perro, agua, 42…"
            onChange={(e) => setConsulta(e.target.value)}
          />
          {consulta && (
            <button
              type="button"
              className="sim-busca-x"
              onClick={() => setConsulta('')}
              aria-label="Borrar la búsqueda"
            >
              <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
                <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" fill="none" />
              </svg>
            </button>
          )}
        </div>
        <p className="sim-pista" aria-live="polite">
          {consulta
            ? `${filas.length} ${filas.length === 1 ? 'resultado' : 'resultados'}`
            : 'Los 100 sueños, del 00 al 99.'}
        </p>
      </div>

      {filas.length === 0 ? (
        <p className="sim-vacio">
          No encontramos ese sueño en la tabla. Probá con una palabra sola:
          {' '}<b>perro</b>, <b>agua</b>, <b>dinero</b>.
        </p>
      ) : (
        <div className="sim-tabla-caja">
          <table className="sim-tabla">
            <caption className="sim-sr">
              Tabla de los sueños de la quiniela: número, significado y un
              atajo para llevarlo al simulador de jugada.
            </caption>
            <thead>
              <tr>
                <th scope="col">Nº</th>
                <th scope="col">Sueño</th>
                <th scope="col"><span className="sim-sr">Llevarlo al cartón</span></th>
              </tr>
            </thead>
            <tbody>
              {filas.map(({ numero, sueno }) => (
                <tr key={numero}>
                  <th scope="row" className="sim-td-num">
                    {String(numero).padStart(2, '0')}
                  </th>
                  <td className="sim-td-sue">{sueno}</td>
                  <td className="sim-td-cta">
                    <button
                      type="button"
                      className="sim-btn sim-btn-mini"
                      onClick={() => onJugar(numero)}
                    >
                      Jugarlo
                      <span className="sim-sr"> con el {String(numero).padStart(2, '0')}, {sueno}</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <p className="sim-aviso">
        La tabla de los sueños es tradición popular, no una regla del juego: no
        cambia la mecánica ni la probabilidad de nada.
      </p>
    </div>
  );
}
